import { render, staticRenderFns } from "./WillHistory.vue?vue&type=template&id=7c4ef282&scoped=true"
import script from "./WillHistory.vue?vue&type=script&lang=js"
export * from "./WillHistory.vue?vue&type=script&lang=js"
import style0 from "./WillHistory.vue?vue&type=style&index=0&id=7c4ef282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4ef282",
  null
  
)

export default component.exports